<script>
import coachesRepository from "@/services/api/coachesRepository";
import { reactive, onMounted, inject } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')

    const state = reactive({
      isEdit: false,
      treinadorId: null,
      loading: false,
      treinador: {
        name: '',
        email: '',
        password: '',
        phone: '',
        cpf: '',
        birth_date: '',
        sex: '',
        cep: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        country: 'Brasil'
      }
    })

    onMounted(() => {
      if (route.params.id && parseInt(route.params.id) > 0) {
        state.isEdit = true
        state.treinadorId = parseInt(route.params.id)
        buscarDados()
      }
    })

    function buscarDados() {
      state.loading = true
      coachesRepository.TreinadorGetId(state.treinadorId).then(response => {
        if (response.data.success) {
          state.treinador = response.data.data
          state.treinador.password = '' // Limpa campo de senha na edicao
        }
      }).catch(error => {
        console.error(error)
        swal({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao buscar dados do treinador'
        })
      }).finally(() => {
        state.loading = false
      })
    }

    function salvar() {
      if (!state.treinador.name || !state.treinador.email) {
        swal({
          icon: 'warning',
          title: 'Atencao',
          text: 'Nome e E-mail sao obrigatorios'
        })
        return
      }

      state.loading = true

      if (state.isEdit) {
        coachesRepository.TreinadorPut(state.treinadorId, state.treinador).then(response => {
          if (response.data.success) {
            swal({
              icon: 'success',
              title: 'Sucesso',
              text: 'Treinador atualizado com sucesso!'
            }).then(() => {
              router.push('/treinadores')
            })
          }
        }).catch(error => {
          console.error(error)
          swal({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao atualizar treinador'
          })
        }).finally(() => {
          state.loading = false
        })
      } else {
        coachesRepository.TreinadorPost(state.treinador).then(response => {
          if (response.data.success) {
            const data = response.data.data
            let msg = 'Treinador cadastrado com sucesso!'

            // Se a senha foi gerada automaticamente, mostra para o usuario
            if (data.generated_password) {
              msg = `Treinador cadastrado com sucesso!\n\nSenha de acesso: ${data.generated_password}\n\nAnote esta senha, ela nao sera exibida novamente.`
            }

            swal({
              icon: 'success',
              title: 'Sucesso',
              text: msg
            }).then(() => {
              router.push('/treinadores')
            })
          }
        }).catch(error => {
          console.error(error)
          let errorMsg = 'Erro ao cadastrar treinador'
          if (error.response && error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message
          }
          swal({
            icon: 'error',
            title: 'Erro',
            text: errorMsg
          })
        }).finally(() => {
          state.loading = false
        })
      }
    }

    function voltar() {
      router.back()
    }

    function buscarCep() {
      if (state.treinador.cep && state.treinador.cep.length >= 8) {
        const cep = state.treinador.cep.replace(/\D/g, '')
        fetch(`https://viacep.com.br/ws/${cep}/json/`)
          .then(response => response.json())
          .then(data => {
            if (!data.erro) {
              state.treinador.street = data.logradouro
              state.treinador.neighborhood = data.bairro
              state.treinador.city = data.localidade
              state.treinador.state = data.uf
            }
          })
          .catch(error => console.error('Erro ao buscar CEP:', error))
      }
    }

    return {
      state,
      salvar,
      voltar,
      buscarCep
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-header pb-0">
      <h5>{{ state.isEdit ? 'Editar Treinador' : 'Novo Treinador' }}</h5>
    </div>
    <div class="card-body">
      <div v-if="state.loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>

      <form v-else @submit.prevent="salvar">
        <!-- Dados Pessoais -->
        <h6 class="text-uppercase text-secondary text-xs font-weight-bolder mb-3">Dados Pessoais</h6>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="form-label">Nome <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.name"
                placeholder="Nome completo"
                required
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="form-label">E-mail <span class="text-danger">*</span></label>
              <input
                type="email"
                class="form-control form-control-sm"
                v-model="state.treinador.email"
                placeholder="email@exemplo.com"
                required
              />
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">Telefone</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.phone"
                placeholder="(00) 00000-0000"
              />
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">CPF</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.cpf"
                placeholder="000.000.000-00"
              />
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">
                Senha
                <span v-if="!state.isEdit" class="text-muted small">(deixe vazio para gerar automaticamente)</span>
                <span v-else class="text-muted small">(deixe vazio para manter atual)</span>
              </label>
              <input
                type="password"
                class="form-control form-control-sm"
                v-model="state.treinador.password"
                placeholder="********"
              />
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">Sexo</label>
              <select class="form-control form-control-sm" v-model="state.treinador.sex">
                <option value="">Selecione</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">Data de Nascimento</label>
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="state.treinador.birth_date"
              />
            </div>
          </div>
        </div>

        <!-- Endereco -->
        <h6 class="text-uppercase text-secondary text-xs font-weight-bolder mb-3 mt-4">Endereco</h6>
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">CEP</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.cep"
                placeholder="00000-000"
                @blur="buscarCep"
              />
            </div>
          </div>
          <div class="col-12 col-md-7">
            <div class="form-group">
              <label class="form-label">Rua</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.street"
                placeholder="Rua, Avenida..."
              />
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label class="form-label">Numero</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.number"
                placeholder="No"
              />
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">Complemento</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.complement"
                placeholder="Apto, Sala..."
              />
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label class="form-label">Bairro</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.neighborhood"
                placeholder="Bairro"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="form-label">Cidade</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.city"
                placeholder="Cidade"
              />
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div class="form-group">
              <label class="form-label">Estado</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="state.treinador.state"
                placeholder="UF"
                maxlength="2"
              />
            </div>
          </div>
        </div>

        <!-- Botoes -->
        <div class="row mt-4">
          <div class="col-12 text-end">
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" @click.prevent="voltar">
              <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">arrow_back</i>
              Voltar
            </button>
            <button type="submit" class="btn btn-sm btn-success" :disabled="state.loading">
              <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">save</i>
              {{ state.isEdit ? 'Atualizar' : 'Cadastrar' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-label {
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}
</style>
